import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { AppearanceSettingsTabShell } from "../AppearanceSettingsTabShell";
import { Separator } from "../../../../components/Separator";
import { TabHeader } from "../../../../components/TabHeader";
import { PositionSection } from "./PositionSection";
import { StyleSection } from "./StyleSection";

export const LauncherStyleTabContent: FC = () => {
  const { t } = useTranslations();

  return (
    <AppearanceSettingsTabShell tabId="launcherStyle" previewMode="launcher">
      <TabHeader
        title={t({
          id: "client-support-page.launcher-style-tab-title",
          defaultMessage: "Launcher Style",
        })}
        subtitle={t({
          id: "client-support-page.launcher-style-tab-subtitle",
          defaultMessage:
            "Set the style and position of the Launcher Icon that will be represented on your website",
        })}
      />
      <Separator className="my-8" />
      <div className="flex flex-col gap-14">
        <StyleSection />
        <PositionSection />
      </div>
    </AppearanceSettingsTabShell>
  );
};
